export const LAST_USER_ACTIVITY_KEY = 'lastUserActivity';
export const CHECKOUT_CART_KEY = 'cart';
export const CHECKOUT_CART_DATA_KEY = 'cartData';
export const DXE_IS_MOBILE_APP = 'dxe.isMobileApp';
